import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Download } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useLang } from '../i18n/LangContext';

const LegalPage = ({ pageKey }) => {
  const { t } = useLang();
  const page = t.legal.pages[pageKey];
  useEffect(() => {
    document.title = `${page.title} | KRUG — Pronađi svoj krug`;
    return () => {
      document.title = 'KRUG — Pronađi svoj krug | Aplikacija za dijasporu';
    };
  }, [page.title]);
  return (
    <div data-testid={`legal-${pageKey}-page`} className="min-h-screen bg-krug-navy">
      <Navbar />
      <main className="max-w-3xl mx-auto px-5 md:px-8 pt-36 pb-24">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-bold text-krug-tealbright hover:text-krug-goldbright transition-colors duration-300"
        >
          <ArrowLeft size={16} />
          {t.legal.back}
        </Link>
        <h1 className="mt-8 font-heading text-4xl md:text-5xl font-extrabold tracking-tight text-white">{page.title}</h1>
        <p data-testid="legal-draft-notice" className="mt-4 inline-flex rounded-full border border-krug-gold/40 bg-krug-gold/10 px-4 py-1.5 text-xs font-bold text-krug-goldbright">
          {t.legal.draft}
        </p>
        <div>
          <button
            type="button"
            data-testid="legal-pdf-btn"
            onClick={() => window.print()}
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm font-bold text-white hover:border-krug-tealbright hover:text-krug-tealbright transition-colors duration-300"
          >
            <Download size={16} />
            {t.legal.pdf}
          </button>
        </div>

        <div className="mt-12 space-y-10">
          {page.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading text-xl font-extrabold text-white">{s.h}</h2>
              {s.p && <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{s.p}</p>}
              {s.lines && (
                <div className="mt-3 rounded-2xl glass-dark px-6 py-5 space-y-1.5 w-fit">
                  {s.lines.map((line) => (
                    <p key={line} className="text-sm md:text-base text-slate-300 leading-relaxed">{line}</p>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>

        {pageKey === 'contact' && (
          <a
            href="mailto:info@krug-app.eu"
            data-testid="contact-email-link"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-krug-gold px-7 py-3.5 font-heading font-bold text-krug-navy hover:bg-krug-goldbright transition-colors duration-300"
          >
            <Mail size={18} />
            info@krug-app.eu
          </a>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
